import React from 'react';
import { Shield, Download, CheckCircle, ArrowRight } from 'lucide-react';
export function PurchaseSection() {
  return <section id="compra" className="py-20 bg-[#0F172A] text-white relative overflow-hidden" data-id="element-118">
      {/* Background Effects */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,#1B5E20_0%,#0F172A_70%)] opacity-40" data-id="element-119"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-120">
        <div className="bg-white text-gray-900 rounded-3xl shadow-2xl overflow-hidden border-4 border-[#F59E0B]" data-id="element-121">
          {/* Header */}
          <div className="bg-[#DC2626] text-white p-6 text-center" data-id="element-122">
            <h2 className="text-3xl md:text-4xl font-black uppercase tracking-wider" data-id="element-123">
              🎯 Acceso Inmediato
            </h2>
            <p className="text-red-100 mt-2 font-medium" data-id="element-124">
              Oferta especial por tiempo limitado
            </p>
          </div>

          <div className="p-8 md:p-12" data-id="element-125">
            <div className="flex flex-col md:flex-row gap-8 items-center justify-between mb-10" data-id="element-126">
              <div className="space-y-4 flex-1" data-id="element-127">
                {['Descargá al finalizar compra', 'Acceso de por vida', 'Material listo para imprimir', 'Editable y reutilizable', 'Compra segura'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-128">
                    <CheckCircle className="w-6 h-6 text-[#1B5E20] flex-shrink-0" data-id="element-129" />
                    <span className="text-lg font-medium text-gray-700" data-id="element-130">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="text-center bg-gray-50 p-6 rounded-xl border border-gray-200 min-w-[250px]" data-id="element-131">
                <p className="text-gray-500 text-lg line-through mb-1" data-id="element-132">
                  Precio Regular: $49.99
                </p>
                <p className="text-5xl font-black text-[#0F172A] mb-2" data-id="element-133">
                  $13.99
                </p>
                <p className="text-[#1B5E20] font-bold text-sm bg-[#1B5E20]/10 py-1 px-3 rounded-full inline-block" data-id="element-134">
                  Ahorrás 72% HOY
                </p>
              </div>
            </div>

            <a href="https://pay.hotmart.com/J104331849I?checkoutMode=10" target="_blank" rel="noopener noreferrer" className="block w-full bg-[#1B5E20] hover:bg-green-800 text-white font-black text-xl md:text-2xl py-5 px-6 rounded-xl text-center shadow-lg transform hover:scale-[1.02] transition-all duration-300 animate-pulse mb-8" data-id="element-135">
              <span className="flex items-center justify-center gap-2" data-id="element-136">
                👉 QUIERO MI MEGAPACK AHORA
                <ArrowRight className="w-6 h-6" data-id="element-137" />
              </span>
            </a>

            <div className="text-center mb-8" data-id="element-138">
              <p className="text-xl font-bold text-[#0F172A]" data-id="element-139">
                Resolvé todo tu año hoy
              </p>
              <p className="text-gray-600" data-id="element-140">
                Enseñá con orden, claridad y tranquilidad
              </p>
            </div>

            {/* Badges */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 border-t border-gray-200 pt-8" data-id="element-141">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-142">
                <Shield className="w-8 h-8 text-[#1B5E20]" data-id="element-143" />
                <span className="font-bold text-sm" data-id="element-144">Compra 100% Segura</span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-145">
                <Shield className="w-8 h-8 text-[#F59E0B]" data-id="element-146" />
                <span className="font-bold text-sm" data-id="element-147">Garantía 7 días</span>
              </div>
              <div className="flex flex-col items-center text-center gap-2" data-id="element-148">
                <Download className="w-8 h-8 text-[#DC2626]" data-id="element-149" />
                <span className="font-bold text-sm" data-id="element-150">Descarga inmediata</span>
              </div>
            </div>
          </div>
        </div>

        {/* Guarantee Badge */}
        <div className="mt-12 text-center max-w-2xl mx-auto" data-id="element-151">
          <img src="https://cdn-icons-png.flaticon.com/512/9513/9513732.png" alt="Garantía de Satisfacción" className="w-24 h-24 mx-auto mb-4 opacity-90" data-id="element-152" />
          <h3 className="text-xl font-bold mb-2" data-id="element-153">
            Garantía de Satisfacción de 7 Días
          </h3>
          <p className="text-gray-300 text-sm" data-id="element-154">
            Si el material no cumple con tus expectativas, te devolvemos el 100%
            de tu dinero. Sin preguntas. El riesgo es todo nuestro.
          </p>
        </div>
      </div>
    </section>;
}